import Normalize from './normalize';
import Proxy from './proxy';
import Read from './csrf/read';
import Retry from './csrf/retry';
import Write from './csrf/write';
import Backbone from '@polleverywhere/backbone';
/*
* `ajaxes` should be clases that can be instantiated by passing an ajax method
* to the constructor. The objects that are returned must have an ajax method.
* `current` is the actual `ajax`. Usually this will be `$.ajax`.
* Returns an ajax function that is the chain of all the passed in arguments.
*/

function ajaxChain(cache) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  var adjustedLength = Math.max(rest.length, 1);
  var ajaxes = rest.slice(0, adjustedLength - 1);
  var current = rest[adjustedLength - 1];

  while (ajaxes.length) {
    var Next = ajaxes.pop();
    current = new Next(cache, current).ajax;
  }

  return current;
} // @namespace Ajax


var Chain = function Chain() {
  this.cache = {};
  this.ajax = ajaxChain(this.cache, Normalize, Proxy, Read, Write, Retry, Backbone.$.ajax // just a plain ajax method, not a class that can be instantiated.
  ); // For debugging/testing only

  /* eslint-disable no-undef */

  if (typeof jasmine !== 'undefined' && jasmine !== null) {
    this.ajax.chain = this;
  }
  /* eslint-enable no-undef */

};

export { Chain as default };